module.exports = __webpack_public_path__ + "static/logo-b652e4d960b11e284090fd7bf8e7a8f1.png";